




















import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class YoutubeFrame extends Vue {
  @Prop()
  src!: string;
}
